import React from 'react';
import styles from '../pages/Workspace/FormBuilder.module.css';

// Text Field Component
export const TextField = ({ id, handleChange }) => (
  <div>
    <label htmlFor={`text-${id}`}>Text Field</label>
    <input className={styles.TextField22} id={`text-${id}`} type="text" onChange={e => handleChange(id, e.target.value)} required />
  </div>
);

// Image Field Component
export const ImageField = ({ id, handleChange }) => (
  <div>
    <label htmlFor={`image-${id}`}>Image URL</label>
    <input id={`image-${id}`} type="url" onChange={e => handleChange(id, e.target.value)} required />
  </div>
);

// Video Field Component
export const VideoField = ({ id, handleChange }) => (
  <div>
    <label htmlFor={`video-${id}`}>Video URL</label>
    <input id={`video-${id}`} type="url" onChange={e => handleChange(id, e.target.value)} required />
  </div>
);

// GIF Field Component
export const GifField = ({ id, handleChange }) => (
  <div>
    <label htmlFor={`gif-${id}`}>GIF URL</label>
    <input id={`gif-${id}`} type="url" onChange={e => handleChange(id, e.target.value)} required />
  </div>
);

// Rating Field Component
export const RatingField = ({ id, handleChange }) => (
  <div>
    <label htmlFor={`rating-${id}`}>Rating</label>
    <select id={`rating-${id}`} onChange={e => handleChange(id, e.target.value)} required>
      <option value="">Select rating</option>
      <option value="1">1</option>
      <option value="2">2</option>
      <option value="3">3</option>
      <option value="4">4</option>
      <option value="5">5</option>
    </select>
  </div>
);

// Input Field Component
export const InputField = ({ id, type, handleChange }) => (
  <div>
    <label htmlFor={`${type}-${id}`}>{type.charAt(0).toUpperCase() + type.slice(1)} Field</label>
    <textview id={`${type}-${id}`} onChange={e => handleChange(id, e.target.value)} />
  </div>
);

// Button Field Component
export const ButtonField = ({ id, handleChange }) => (
  <div>
    <label htmlFor={`button-${id}`}>Button Label</label>
    <input id={`button-${id}`} type="text" onChange={e => handleChange(id, e.target.value)} />
  </div>
);
